module.exports = __webpack_public_path__ + "static/assets/6c0f71990a33b60b81aa09b5eaaa95e2.svg";